import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './BlogPost.css';
import provenanceImg from '../img/blog/provenance-blog.jpg';
import BlogTemplate from '../components/common/BlogTemplate';

class BlogPost extends Component {
  render() {
    return (
      <BlogTemplate {...this.props}>
        <h1>Provenance – without the facts and evidence it’s just a story.</h1>
        <h2>
          So, what is provenance?  According to the Oxford Dictionary, it
          is “the place, origin or earliest known history of something”
          and originates from the French verb “provenir”. Of course, in
          the world of fine art the need to establish the origins and history
          of the item in question is critical.  However, the need to demonstrate
          provenance in what we eat and drink is becoming ever more important.
          Who will ever forget the “Horsemeat” scandal of 2013?
        </h2>
        <p>
          The ability to understand the provenance has never been more important
          to the whisky, premium spirits and craft beer drinker.  Today’s consumers
          want to understand more about the ingredients, the processes and the supply
          chains used to provide their drink of choice. They want transparency
          and need to trust in the brands they purchase, and they are tech-savvy
          enough to expect it to be accessible at their fingertips.
        </p>
        <p>
          How therefore, do distillers, brewers and brand owners provide the facts,
          the evidence, the proof that provides the belief in their brand.  Without
          facts and evidence, it’s just a story and can that story be trusted?
        </p>
        <p>
          The emergence of blockchain technology is allowing producers and brand
          owners to build trust in their products, processes and supply chains.
          So, what is blockchain? Without getting too technical, blockchain
          provides an immutable record where data cannot be destroyed or falsified.
          It allows distillers and brewers to gather, record and share information
          with consumers and it allows consumers to understand the provenance of
          their purchase and have confidence in its authenticity.
        </p>
        <img src={provenanceImg} alt="From Barley to Bottle - Adelphi Distillery" />
        <p>
          At arc-net we are working with a number of premium distillers and craft
          brewers to help them share their unique storybook with their customers
          and provide complete “barley to bottle” traceability. The arc-net
          blockchain platform, Distilled ID, provides the means to give every product
          a voice, share the unique story of a brand and increase trust, loyalty
          and stakeholder engagement.
        </p>
        <p>
          To find out how Distilled ID can help build trust, provide unique consumer
          intelligence, improve brand security, and add real value to your brand,
              <Link to="/contact"> send us an email.</Link>
        </p>
      </BlogTemplate >
    );
  }
}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/blogposts/provenanceBlog.js